module.exports = __webpack_public_path__ + "static/media/edit.613e9253.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/edit.svg
// module id = 6368
// module chunks = 0